import React from 'react';
import { Card, Result, Button, Typography, Space } from 'antd';
import { LockOutlined, UserSwitchOutlined } from '@ant-design/icons';

const { Text } = Typography;

const NoAccessComponent = ({ logout }) => {
    const handleLogout = () => {
        if (logout && typeof logout === 'function') {
            logout();
        } else {
            // Fallback behavior if logout is not provided
            window.location.reload(); // Or redirect to login page
        }
    };

    return (
        <div style={{ maxWidth: 500, margin: '40px auto', padding: '20px' }}>
            <Card>
                <Result
                    status="403"
                    title="Доступ ограничен"
                    subTitle="Ваши роли в системе не позволяют работать ни с одним из модулей"
                    icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
                    extra={
                        <Space direction="vertical">
                            <Button
                                type="primary"
                                icon={<UserSwitchOutlined />}
                                onClick={() => window.location.href = 'mailto:admin@example.com'}
                            >
                                Связаться с администратором
                            </Button>

                            <Button
                                onClick={handleLogout}
                            >
                                Выйти
                            </Button>
                        </Space>
                    }
                />

                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <Text type="secondary">
                        Для получения доступа к системе обратитесь к администратору
                    </Text>
                </div>
            </Card>
        </div>
    );
};

export default NoAccessComponent;